import axios from 'axios'
import config from '../config/app'

const PATH = '/milestone'

const milestoneAPI = {
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyData ($companyId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + PATH + '/' + $companyId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  startNextMilestone (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-next-milestone', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default milestoneAPI



// WEBPACK FOOTER //
// ./src/api/milestone.js